/* ==========================================================================
   Helpers > Dom
   ========================================================================== */

/**
 * Get next sibling
 * @param {HTMLElement} element
 * @param {string} selector where to stop
 * @returns {HTMLElement} next sibling
 */
function getNextSibling(element, selector) {
    /* Get the next sibling element */
    let sibling = element.nextElementSibling;

    if (!sibling) {
        return null;
    }

    /* If there's no selector, return the first sibling */
    if (!selector) return sibling;

    /**
     * If the sibling matches our selector, use it
     * If not, jump to the next sibling and continue the loop
     */
    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling;
    }

    return sibling;
}

/**
 * Get previous sibling
 * @param {HTMLElement} element
 * @param {string} selector where to stop
 * @returns {HTMLElement} previous sibling
 */
function getPreviousSibling(element, selector) {
    /* Get the next sibling element */
    let sibling = element.previousElementSibling;

    if (!sibling) {
        return null;
    }

    /* If there's no selector, return the first sibling */
    if (!selector) return sibling;

    /**
     * If the sibling matches our selector, use it
     * If not, jump to the next sibling and continue the loop
     */
    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.previousElementSibling;
    }

    return sibling;
}

/* Exports */
module.exports = {
    getNextSibling,
    getPreviousSibling
};
